import NarinLayout from "components/NarinLayout";
import SideFilter from "../../components/Desktop/SideFilter";
import ListIcon from "icons/ListIcon";
import GridIcon from "icons/GridIcon";

import { Pagination, PaginationProps, Spin } from "antd";
import { useState, useEffect } from "react";
import HeroImage from "components/Desktop/HeroImage";
import { useGetProductList } from "services/product";
import ProductList from "../../components/Desktop/ProductList";
import { CustomPaginationItem } from "components/Desktop/CustomPaginationItem";
// import { E_ORDER_STATUS } from "constants/common";
import useIsDesktopStore from "stores/isDesktop";
import { useSearchParams } from "react-router-dom";

const HomePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isListView, setIsListView] = useState<boolean>(false);
  const { isDesktop } = useIsDesktopStore();

  // Get page from URL or default to 1
  const pageFromUrl = searchParams.get("page");
  const [currentPage, setCurrentPage] = useState<number>(
    pageFromUrl ? parseInt(pageFromUrl) : 1
  );

  // Get categories from URL or default to empty array
  const categoriesFromUrl = searchParams.get("categories");
  const [filterCate, setFilterCate] = useState<string[]>(
    categoriesFromUrl ? categoriesFromUrl.split(",") : []
  );

  // const [filterOrderStatus, setFilterOrderStatus] = useState<E_ORDER_STATUS>(
  //   E_ORDER_STATUS.ALL
  // );

  // Sync URL with state when component mounts
  useEffect(() => {
    const params = new URLSearchParams(searchParams);

    if (currentPage !== 1) {
      params.set("page", currentPage.toString());
    } else {
      params.delete("page");
    }

    if (filterCate && filterCate.length > 0) {
      params.set("categories", filterCate.join(","));
    } else {
      params.delete("categories");
    }

    setSearchParams(params);
  }, [currentPage, filterCate]);

  const { productList, isLoading } = useGetProductList(filterCate, currentPage);

  const onChangePage: PaginationProps["onChange"] = (page) => {
    setCurrentPage(page);
  };

  const onChangeFilter = (categoryId: string[]) => {
    setFilterCate(categoryId);
    // Reset to page 1 when filter changes
    setCurrentPage(1);
  };

  // const handleOnChangeOrderStatus = (value: E_ORDER_STATUS) => {
  //   setFilterOrderStatus(value);
  // };

  return (
    <NarinLayout>
      <HeroImage />
      <div className=" xl:flex xl:gap-2 xl:pt-8 p-4">
        <SideFilter onChange={onChangeFilter} defaultValue={filterCate} />
        <div className="w-full ">
          {isDesktop && (
            <div className="flex justify-between items-center mb-4">
              <div></div>
              <div className="flex gap-4">
                <div
                  className="cursor-pointer"
                  onClick={() => setIsListView(true)}
                >
                  <ListIcon style={{ opacity: isListView ? 1 : 0.5 }} />
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => setIsListView(false)}
                >
                  <GridIcon style={{ opacity: isListView ? 0.5 : 1 }} />
                </div>
              </div>
            </div>
          )}
          {/* <div className="flex justify-between items-center mt-4">
            <div className="text-xl"></div>
            <div className="flex gap-2 text-sm items-center">
              <div>เรียงสินค้าตาม</div>
             
              <Select
                className="order-history-select"
                onChange={handleOnChangeOrderStatus}
                style={{
                  width: "175px",
                }}
                size="large"
                value={filterOrderStatus}
                options={[
                  {
                    label: OrderStatusLabels.ALL,
                    value: E_ORDER_STATUS.ALL,
                  },
                  {
                    label: OrderStatusLabels.COMPLETED,
                    value: E_ORDER_STATUS.COMPLETED,
                  },
                  {
                    label: OrderStatusLabels.CONFIRMED,
                    value: E_ORDER_STATUS.CONFIRMED,
                  },
                  {
                    label: OrderStatusLabels.PENDING,
                    value: E_ORDER_STATUS.PENDING,
                  },
                ]}
              />
            </div>
          </div> */}
          <div className="bg-white p-4 mt-4 lg:mt-0">
            <Spin tip="Loading" size="large" spinning={isLoading}>
              <div className="min-h-screen">
                <ProductList
                  isLoading={false}
                  isList={isListView}
                  data={productList?.items}
                />
              </div>
            </Spin>
            <div className="mt-4 justify-center flex">
              <Pagination
                itemRender={CustomPaginationItem}
                className="pagination-home"
                current={currentPage}
                onChange={onChangePage}
                total={productList?.meta.totalItems}
                showSizeChanger={false}
                pageSize={20}
                responsive
              />
            </div>
          </div>
        </div>
      </div>
    </NarinLayout>
  );
};
export default HomePage;
